'use client';

import React, { type ReactElement, useMemo, useState } from 'react';
import SearchHeader from '@/features/homeSearch/components/search-header.component';
import Layout from '@/common/components/layout';
import { ResponsiveWrapper } from '@/common/components/wrapper';
import debounceFunc from '@/common/utils/debounce.utility';
import TenantSearchResults from './tenant-search-results.component';

export default function TenantSearchMain(): ReactElement {
  const [value, setValue] = useState('');
  const [searchTerm, setSearchTerm] = useState('');

  const applySearch = useMemo(
    () =>
      debounceFunc<(next: string) => void>((next) => {
        setSearchTerm(next.trim());
      }, 400),
    []
  );

  const clearSearch = () => {
    setValue('');
    setSearchTerm('');
  };

  return (
    <Layout
      responsiveAppbar
      appbar={{
        logo: true,
        cartWidget: true,
        // Search input is handled by SearchHeader (tenant branding, not Witro marketplace).
        showSearch: false,
      }}
      className="!min-h-screen bg-white"
    >
      <ResponsiveWrapper className="flex w-full flex-col px-4 pt-3 lg:pt-6">
        <SearchHeader
          value={value}
          isSearching={false}
          clearSearch={clearSearch}
          autoFocus
          onChange={(event) => {
            const next = event.target.value;
            setValue(next);
            applySearch(next);
          }}
        />

        <TenantSearchResults searchTerm={searchTerm} />
      </ResponsiveWrapper>
    </Layout>
  );
}
